import defaultColumnWidths from "@app-utils/oems/defaultColumnWidths";
import { styled } from "@enfusion-ui/web-core";
import { ICellRendererParams } from "ag-grid-enterprise";
import React, { CSSProperties } from "react";

export type FillerProps = {
  percent: number;
  rounded: boolean;
  bgColor?: string;
};

const LoadingBarContainer = styled.div`
  height: 30px;
  width: 100%;
  position: relative;
  padding: 2px;
`;

const FillerContainer = styled.div<FillerProps>`
  display: inline-block;
  height: 72%;
  width: ${(props: FillerProps) => props.percent + "%"};
  background-color: ${({ bgColor }) => (bgColor ? bgColor : "var(--primary)")};
  border-radius: ${({ rounded }) => (rounded ? "2px" : "0px")};
  transition: width 300ms ease-in-out;
  text-align: center;
  position: absolute;
  top: 2px;
  left: 2px;
`;

const Label = styled.span`
  position: absolute;
  left: 22%;
  z-index: 2;
`;

const LoadingBar: React.FC<{
  percent: number;
  text?: string | null;
  style?: CSSProperties;
  bounce?: boolean;
  rounded?: boolean;
  backgroundColor?: string;
  progressBarColor?: string;
}> = ({
  text = "",
  style,
  rounded = true,
  percent,
  backgroundColor = "var(--text-muted)",
  progressBarColor,
}) => {
  return (
    <LoadingBarContainer style={{ backgroundColor: backgroundColor, ...style }}>
      <Label>{text}</Label>
      <FillerContainer
        percent={percent}
        rounded={rounded}
        bgColor={progressBarColor}
      ></FillerContainer>
    </LoadingBarContainer>
  );
};

// export LoadingBar;
const PercentageCellRenderer: React.FC<ICellRendererParams> = React.memo(
  ({ data, value, valueFormatted }) => {
    if (!data) {
      return null;
    }
    const opacity = data.completed ? 0.45 : 0.95;
    return (
      <LoadingBar
        style={{
          width: defaultColumnWidths.FilledPct,
          opacity,
        }}
        rounded
        percent={Number(value) * 100}
        text={valueFormatted}
        backgroundColor="transparent"
      />
    );
  }
);

PercentageCellRenderer.displayName = "PercentageCellRenderer";
export default PercentageCellRenderer;
